import { createFileRoute } from '@tanstack/react-router'
import { OrdersPanel } from '@/components/me/orders-panel'

export const Route = createFileRoute('/orders/')({
  component: OrdersPanel,
})
